"use client";
import { jsx } from "react/jsx-runtime";
import Script from "next/script";
import { COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY, COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON } from "../constants.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage/index.js";
const TranscendIntegrationManagerClient = ({
  isTranscendConsentManagementEnabled,
  scriptSrc
}) => {
  const [consentProviderSessionStorage] = useSessionStorage(
    COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY,
    isTranscendConsentManagementEnabled
  );
  const isTranscendEnabled = isTranscendConsentManagementEnabled || consentProviderSessionStorage === COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON;
  if (!isTranscendEnabled || !scriptSrc) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Script,
    {
      id: "CostcoConsentManagerScript",
      src: scriptSrc,
      strategy: "afterInteractive"
    }
  );
};
export {
  TranscendIntegrationManagerClient
};
